'use client';

import type { LocationFinderResolved } from './types';
import { ZipCityButton } from '@/components/ZipCity';
import { useOptionalRenderContext } from '@/lib/render/RenderContextProvider';

interface LocationFinderComponentProps {
  resolved: LocationFinderResolved;
}

export const LocationFinderComponent = ({
  resolved,
}: LocationFinderComponentProps) => {
  const { inputPlaceholder, buttonLabel, additionalText, anchor } = resolved;
  // On the search results page the input starts filled with the term the
  // visitor searched for, so they can refine it instead of retyping. The
  // entity exists nowhere else, so every other instance starts empty.
  // Optional read: the finder is also rendered outside a render tree (the
  // footer, the Navigation Grid), where there is no provider to throw about.
  const ctx = useOptionalRenderContext();

  return (
    // `max-w-3xl` is a measure, not a container (70.14-Widget-Width § 5): the
    // input row reads better short than stretched across the full content
    // width. The gutter that keeps it off the screen edge on mobile comes from
    // the SlotRenderer wrapper.
    <div className="mx-auto w-full max-w-3xl pt-3 text-center">
      <div className="mx-auto max-w-2xl">
        <ZipCityButton
          placeholder={inputPlaceholder}
          buttonLabel={buttonLabel}
          anchor={anchor}
          initialQuery={ctx?.entities.locationSearch?.term}
        />
      </div>
      {additionalText && (
        <p className="text-foreground/60 mt-4 text-sm">{additionalText}</p>
      )}
    </div>
  );
};
